
import * as ko from "knockout";
import * as $ from "jquery";
import deMessages from "devextreme/localization/messages/de.json";
import { locale, loadMessages } from "devextreme/localization";

import template from "./bao-app.html";
import aboutDialogTemplate from "./bao-app-about-dialog.html";
import appNameFinito from "./app-name-finito.html";
import appNameSynoset from "./app-name-synoset.html";
import appNameUadm from "./app-name-uadm.html";
import appNameCheckware from "./app-name-checkware.html";
import BaoMenu from "./../../services/bao-menu";
import baoRouter from "../../services/bao-router";
import Bao from "../../services/bao-service";
import TabController from "./../../factories/tab-controller";
import BaoDialogViewModel from "./../../factories/bao-dialog";

import { PasswordChanger } from "./../../factories/password-changer/password-changer";
import { TenantSwitcher } from "./../../factories/tenant-switcher/tenant-switcher";
import { Loading } from "./../../components/loading/loading";

import { ApplicationIds } from "./../../../core/application-ids";


// import Scrollbar from "perfect-scrollbar";
// import baoMenu from "../../services/bao-menu";
// import jsonDemo from "./bao-app2-demo.json";

export class BaoApp2 {

    constructor() {
        this._subs.push(this.AppNameHtml.subscribe(() => {
            setTimeout(() => {
                this.AppNameWidth($(this.AppNameContainer()).outerWidth() + "px");
            }, 1);
        }))
        BaoMenu.registerEvent((btn) => {
            this.ClickHandler(btn);
        });
        Bao.ErrorHandling = true;
    }

    public BaoMenu = BaoMenu;
    public Bao = Bao;

    public HeaderContainer = ko.observable<HTMLElement>();
    public TabController: TabController;
    public SwitcherEnabled = ko.observable(false);
    public LogoEnabled = ko.observable(false);
    public SearchEnabled = ko.observable(true);
    public SearchText = ko.observable("");
    public AppNameHtml = ko.observable();
    public AppNameContainer = ko.observable();
    public PopUpOpen = ko.observable(false);
    public LoggedIn = ko.observable(false);
    public ContentElement = ko.observable<HTMLElement>();
    public AppNameWidth = ko.observable("125px");

    public IconsEnabled = ko.observable(false);
    public Open = true;
    public Counter = 0;
    public Updating = ko.observable(false);
    public TabContainerPaddingTop = ko.observable<number>(95);

    public IsLoading = ko.observable(true);
    public Initialized = ko.observable(false);
    public SidebarElement = ko.observable<HTMLElement>();
    public LanguageList = ko.observable([]);
    public currentSelectedLanguage = ko.observable("");
    private _subs: KnockoutSubscription[] = [];

    private sessionCheckIntervall = 60;

    private refSessionCheck = null;

    public RemoveSearchText() {
        this.SearchText("");
    }

    public LoginSuccessfull = (reloadNeeded = true) => {
        if (reloadNeeded) {
            window.location.reload();
            return;
        }
        let initRoute = window.location.hash;
        window.location.hash = "";
        baoRouter.init();
        this.IsLoading(true);
        if (window.__offline) {
            this.LoginSuccessfullComplete();
            return $.Deferred().resolve().promise();
        }
        return $.when(Bao.initSession(), this.BaoMenu.init()).then(() => {
            let defaultRoute = "search";
            if (window.__develop == false || window.__develop == null) {
                defaultRoute = this.OpenDefaultTabs();
            }
            // baoRouter.setHash("dashboardv2");
            if (initRoute == "/" || initRoute == "" || initRoute == "#/") {
                initRoute = defaultRoute;
            }
            this.LanguageList = Bao.Session.AvailableLanguages;
            this.currentSelectedLanguage(Bao.Session.Language.Symbol());
            baoRouter.setHash(initRoute.replace("#/", ""));
            this.LoginSuccessfullComplete();
        });
    }

    public initTabControllerSubscribes() {
        this._subs.push(this.TabController.Height.subscribe(() => {
            this.calculateTabControllerPaddingTop();
        }));
        this.calculateTabControllerPaddingTop();
    }

    private calculateTabControllerPaddingTop() {
        this.TabContainerPaddingTop(this.TabController.Height() + 95);
    }

    public TogglePopUp() {
        this.PopUpOpen(!this.PopUpOpen());
    }

    public Logout(forced = false) {
        this.PopUpOpen(false);
        this.IsLoading(true);
        this.Initialized(false);
        this.LoggedIn(false);
        $.when(Bao.post("Login/Logout"), this.TabController.CloseAll(true, true)).then(() => {
            window.location.replace(window.location.pathname + '?mode=logout');
        });
    }

    public ChangePassword() {
        this.PopUpOpen(false);
        const passwordChanger = new PasswordChanger();
        passwordChanger.Open();
    }

    public ChangeTenant() {
        this.TabController.CloseAll(true).then((closeResult) => {
            if (closeResult) {
                const tenantSwitcher = new TenantSwitcher(true);
                tenantSwitcher.AutoSelect = false;
                tenantSwitcher.Open().then((result) => {
                    this.IsLoading(true);
                    window.location.reload();
                });
            }
        });
    }

    public Search() {
        window.location.hash = "search";
    }
    public init() {
        Loading.register(this.IsLoading);
        this.IsLoading(true);
        Bao.initBackend();
        return this.CookieLogin().then(() => {

            return this.CheckSession().then((result) => {
                this.IsLoading(false);
                if (result) {
                    return this.LoginSuccessfull(false);
                } else {
                    this.Initialized(true);
                }
            })
                .fail(() => {
                    this.IsLoading(false);
                    this.Initialized(true);
                });
        });
    }

    private OpenDefaultTabs(): string {
        // const initHash = baoRouter.getHash();
        let defaultHash = "";
        switch (ko.unwrap(Bao.Session.Application.ApplicationId)) {
            case ApplicationIds.Checkware:
                defaultHash = "start";
                break;
            case ApplicationIds.Uadm:
                break;
            case ApplicationIds.Synoset:
                defaultHash = "startsynoset"
                break;
            case ApplicationIds.Finito:
                defaultHash = "finitostart";
                break;
        }
        if (defaultHash) {
            baoRouter.setHash(defaultHash);
        } else {
            defaultHash = "search";
        }
        baoRouter.setHash("search");
        this.TabController.Tabs().forEach(t => {
            t.IsClosable(false);
            t.EnableDirtyTracking(false);
        });
        return defaultHash;
    }

    private ClickHandler(value) {
        var actionKey = value.ActionKey();
        if (actionKey) {
            switch (value.ActionKey()) {

                case "RibbonButtonAbout":
                case "actionInfo":
                    this.LoadAboutDialog();
                    break;
                case "actionLogout":
                    this.Logout();
                    break;
                case "actionChangeMandator":
                    this.ChangeTenant();
                    break;
                case "actionChangePassword":
                    this.ChangePassword();
                case 'Dashboard':
                    const dashbaord = this.TabController.SearchTabByObjectId('Start');
                    if (dashbaord) {
                        this.TabController.SelectTab(dashbaord);
                    }
                    break;
                case "ChangeLanguage":
                    this.changeLanguage(value.Symbol().toLowerCase());

            }
            if (actionKey.toLowerCase().indexOf("actionchangetheme") > -1) {
                this.changeTheme(value.ActionKey().toLowerCase());
            }
        }
    }

    public changeLanguage(language) {
        Bao.post("Bao/SetLanguage", JSON.stringify({ selectedLanguage: language.trim() }), (result) => {
            localStorage.languageSymbol = result;
            window.location.reload();
        })
    };
    public changeTheme(themeName) {
        Bao.post("Bao/SetUserProfile", JSON.stringify({ key: "Theme", value: themeName.trim() }), (result) => { window.location.reload() })
    };
    public LoadAboutDialog() {
        Bao.get("Application/AboutDialogModel", function (value) {
            var dialogModel = new BaoDialogViewModel();
            dialogModel.Width(350);
            dialogModel.Title(Bao.Session.ApplicationName());

            var vm = {
                clickCount: 0,
                visibleAssemblyList: ko.observable(false),
                onClickShowVersionNumbers: () => {
                    var vm = dialogModel.ViewModel();
                    vm.clickCount++;
                    if (vm.clickCount >= 5) {
                        vm.visibleAssemblyList(true);
                        dialogModel.Width(500);
                    }
                }
            };

            ko.map.fromJS(value, vm);
            dialogModel.ViewModel(vm);
            dialogModel.Template(aboutDialogTemplate);
            dialogModel.Open();
        });
    };

    public dispose() {
        this._subs.forEach((s) => {
            s.dispose();
        });
    }

    private LoginSuccessfullComplete() {
        if (!this.AppNameHtml()) {
            //no custom app name set - set by application id
            this.SetAppNameByApp();
        }
        this.SetDevExtremeLanguage();
        this.LoggedIn(true);
        this.IsLoading(false);
        this.Initialized(true);
        this.SessionChecker();
    }
    private SetAppNameByApp() {
        switch (ko.unwrap(Bao.Session.Application.ApplicationId)) {
            case ApplicationIds.Checkware:
                this.AppNameHtml(appNameCheckware);
                break;
            case ApplicationIds.Synoset:
                this.AppNameHtml(appNameSynoset);
                break;
            case ApplicationIds.Uadm:
                this.AppNameHtml(appNameUadm);
                break;
            case ApplicationIds.Finito:
            default:
                this.AppNameHtml(appNameFinito);
                break;
        }
    }

    private SetDevExtremeLanguage() {
        loadMessages(deMessages);
        locale(Bao.Session.Language.Symbol().substr(0, 2));
    }

    private SessionChecker() {
        clearInterval(this.refSessionCheck);
        this.refSessionCheck = setInterval(() => {
            this.CheckSession().then((result) => {
                if (result == false) {
                    this.Logout(true);
                }
            });
        }, this.sessionCheckIntervall * 1000);
    }

    private CheckSession(): JQueryPromise<boolean> {
        if (window.__develop) {
            return $.Deferred().resolve(true).promise();
        }
        return Bao.Session.RenewSession().then((sessionResult: boolean) => {
            return sessionResult;
        })
    }

    private CookieLogin() {
        const def = $.Deferred<boolean>();
        Bao.post("Login/CookieLogin")
            .then((response) => {
                def.resolve(response.result);
            })
            .fail(() => {
                def.resolve(false);
            });
        return def.promise();
    }
}

export interface IBaoApp2Params {
    tabController: TabController;
    appNameWidth?: KnockoutObservable<string> | string;
}

export default {
    viewModel: {
        createViewModel: function (params: IBaoApp2Params, componentInfo) {
            const e: HTMLElement = componentInfo.element;
            let vm: BaoApp2 = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new BaoApp2();
            vm.TabController = params.tabController;
            vm.initTabControllerSubscribes();
            if (componentInfo.templateNodes && componentInfo.templateNodes.length > 0) {
                vm.AppNameHtml($("<div>").append(componentInfo.templateNodes).html());
            }
            if (params.appNameWidth) {
                vm.AppNameWidth(ko.unwrap(params.appNameWidth));
            }
            e.classList.remove("cloak");
            vm.init();
            return vm;
        }
    },
    template: template
};